module.exports = __webpack_public_path__ + "static/media/btn-scroll-to-top.06c0bad8.svg";